import React from "react";

const restApiHost = 'https://admin.sagax.software/storage/';
export {restApiHost};